import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M10.613 2.006c.182.018.359.037.539.052 1.168.096 2.3.458 3.306 1.06a7.97 7.97 0 0 1 3.836 5.347c.17.794.21 1.61.123 2.417a7.9 7.9 0 0 1-1.496 3.92c-.068.091-.068.144.017.228a2768 2768 0 0 1 4.63 4.628q.043.04.09.07L19.388 22l-.087-.082-4.805-4.808a.17.17 0 0 0-.194.014 7.7 7.7 0 0 1-2.657.912 8.06 8.06 0 0 1-9.1-6.194 8.064 8.064 0 0 1 5.884-9.584 7.4 7.4 0 0 1 1.608-.233q.084-.006.166-.025zM5.547 10.07a4.85 4.85 0 0 0 4.842 4.865 4.84 4.84 0 0 0 4.868-4.85 4.846 4.846 0 0 0-4.84-4.865 4.86 4.86 0 0 0-4.873 4.85z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }